import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import {Feature} from 'molbio/feature-libraries/FeatureLibrary';

class EditableTableItemView extends Backbone.View<Backbone.Model> {
  model!: Feature;

  static initClass(): void {
    this.prototype.tagName = 'tr';
  }

  events(): Backbone.EventsHash {
    return {};
  }

  initialize(options: unknown): void {
    this.registerListeners();
  }

  die(): void {
    this.stopListening();
    this.undelegateEvents();
  }

  unhover(): void {
    assertAndContinue(false, 'Expected to be dead codepath');
  }

  handleUnhoverIcon(): void {
    assertAndContinue(false, 'Expected to be dead codepath');
  }

  registerListeners(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableFocus', this.handleFocus);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableHover', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableUnhover', this.unhover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableRevert', this.update);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableCloseColorPicker', this.closeColorPicker);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableOpenColorPicker', this.openColorPicker);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableRevert', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableInputChange', this.handleInputChange);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:selected', this.updateSelected);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableSetEditables', this.setEditables);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableHoverIcon', this.handleHoverIcon);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'tableUnhoverIcon', this.handleUnhoverIcon);
  }

  handleInputChange(field: string, value: string): void {
    const $field = this.$getField(field);
    if ($field.text() !== value) {
      $field.text(value);
    }
  }

  $getField(field: string): JQuery {
    return this.$('[data-type]').filter(function () {
      // @ts-expect-error shadowing of this
      return $(this).data('type') === field;
    });
  }

  closeColorPicker(field: string): void {
    this.$getField(field).popover('hide');
  }

  openColorPicker(field: string): void {
    this.$getField(field).popover('show');
  }

  handleHoverIcon(field: string, selector: string): void {
    this.$getField(field).parents('td').find(selector).addClass('hover');
  }

  handleHover(field: string, type: unknown): void {
    this.$getField(field).addClass('hover');
  }

  handleFocus(field: string, type: unknown): void {
    this.$getField(field).addClass('focus');
    this.$getField(field).addClass('text-editable');
  }

  updateSelected(): void {
    this.$el.toggleClass('active', this.model.selected());
  }

  setEditables(
    editableFields: Array<string>,
    updateFn: (e: FocusEvent) => void,
    revertFn: (e: KeyboardEvent) => void
  ): void {
    for (const field of editableFields) {
      const $editables = this.$('.editable-text[data-type]').filter(function () {
        // @ts-expect-error shadowing of this
        return $(this).data('type') === field;
      });
      // @ts-expect-error Benchling-specific helper
      $editables.inlineEditable(updateFn, revertFn);
    }

    _.defer(() => {
      this.$('div.relative').each(function (index: number, element: Element) {
        // @ts-expect-error shadowing of this
        $(element).height($(this).parent('td').height());
      });

      this.$('div.relative.middle-aligned').each(function (index: number, element: Element) {
        // @ts-expect-error shadowing of this
        $(element).css('line-height', `${$(this).height()}px`);
      });
    }, this);
  }

  update(): void {
    this.model.trigger('render', this.model);
  }

  // @ts-expect-error Inconsistent return types
  render(): void {
    this.$el.addClass('editable-table-row');
    this.model.trigger('render', this.model);
  }
}
EditableTableItemView.initClass();

export default EditableTableItemView;
